// extracted by mini-css-extract-plugin
module.exports = {"TMAPInfo":"TmapInfo_TMAPInfo__2l0AL","Label":"TmapInfo_Label__1SiAO","Info":"TmapInfo_Info___bfj1"};